import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  background: {
    type: 'string',
    default: 'bg-anil-dark',
  },
  backgroundImg: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  hasMobileImage: {
    type: 'boolean',
    default: false,
  },
  backgroundImgMobile: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  fullHeight: {
    type: 'boolean',
    default: false,
  },
  ...Common,
};
